import { SimpleSubscription } from "~/modules/reporter/CustomObservable/SimpleSubscription";
import { SimpleObservableImpl } from "~/modules/reporter/CustomObservable/SimpleObservable";
import { SimpleObserver } from "~/modules/reporter/CustomObservable/SimpleObserver";

export class SimpleSubject<T> extends SimpleObservableImpl<T> implements SimpleSubscription {
    private observers: Array<SimpleObserver<T>> = [];

    constructor() {
        super();
    }

    subscribe(observer: SimpleObserver<T>): SimpleSubscription {
        this.observers.push(observer);
        return {
            unsubscribe: () => {
                const index = this.observers.indexOf(observer);
                if (index !== -1) {
                    this.observers.splice(index, 1);
                }
            }
        };
    }

    next(value: T): void {
        this.observers.forEach((observer) => observer.next(value));
    }

    unsubscribe(): void {
        this.observers = [];
    }

    asObservable(): SimpleObservableImpl<T> {
        return new SimpleObservableImpl((subscriber) => {
            const subscription = this.subscribe(subscriber);
            return () => subscription.unsubscribe();
        });
    }
}
